// extracted by mini-css-extract-plugin
export default {"personList":"_28540184db31fa71","personListRow":"d26ff43b47891dd0","personItem":"_16dc108902021a6d","mandatory":"_11c173b971afb3bf"};